import { getConfiguration } from './configuration';
import { getAmountInCent } from './getAmountInCent';
import { getCurrencyValue } from './getCurrencyValue';

export function convertInAlternativeCurrency(amount) {
	const conf = getConfiguration();
	if(conf.ac?.en) {
		const decimalValueOriginalCurrency = parseFloat(amount / conf.cs.m);
		const rateToNewCurrency = 1 / conf.ac.rate;
		let decimalValueNewCurrency = decimalValueOriginalCurrency * rateToNewCurrency;
		decimalValueNewCurrency = decimalValueNewCurrency + "";
		if(decimalValueNewCurrency.indexOf(".") > 0) {
			const intPart = decimalValueNewCurrency.split(".")[0];
			let decimalPart = decimalValueNewCurrency.split(".")[1].substring(0, conf.ac.nd);
			if(decimalPart.length < conf.ac.nd) {
				decimalPart = decimalPart + "0";
			}
			if(decimalPart === '0') {
				decimalValueNewCurrency = intPart;
			}
			else {
				decimalValueNewCurrency = intPart + "." + decimalPart;
			}
		}
		const centValueNewCurrency  = getAmountInCent(parseFloat(decimalValueNewCurrency), conf.ac.m);
		const finalValue = getCurrencyValue(centValueNewCurrency, conf.ac.m, conf.ac.nd, conf.ac.cur);
		return finalValue;	
	}
	return null;
}
